import React, { useEffect, useState } from "react";
import { API_BASE_URL, authFetch } from "../api";

/** Campos geridos pela gestão (4.13): somente leitura; segredo já vem mascarado. */
export default function CamposGestao() {
  const [estado, setEstado] = useState({ status: "carregando" });

  useEffect(() => {
    let vivo = true;
    (async () => {
      let e;
      try {
        const res = await authFetch(`${API_BASE_URL}/admin/gestao/campos/`, {
          headers: { Accept: "application/json" },
        });
        if (res.status === 403 || res.status === 404) {
          e = { status: "erro", mensagem: "Gestão indisponível para este acesso." };
        } else if (!res.ok) {
          e = { status: "erro", mensagem: "Não foi possível carregar os campos." };
        } else {
          const dados = await res.json();
          e = { status: "ok", dados: { ...dados, campos: dados.campos || [] } };
        }
      } catch {
        e = { status: "erro", mensagem: "Não foi possível conectar. Tente novamente." };
      }
      if (vivo) setEstado(e);
    })();
    return () => {
      vivo = false;
    };
  }, []);

  const box = { marginTop: 24, display: "flex", flexDirection: "column", gap: 10 };
  if (estado.status === "carregando") return <section style={box}><p>Carregando...</p></section>;
  if (estado.status === "erro") return <section style={box}><p role="alert">{estado.mensagem}</p></section>;
  const { ativo, aviso, campos } = estado.dados;
  if (!ativo) {
    return <section style={box}><h2>Gestão</h2><p role="status">A gestão está desligada neste app.</p></section>;
  }
  return (
    <section style={box}>
      <h2>Gestão</h2>
      <p>{aviso}</p>
      {campos.map((c) => (
        <div key={c.chave} style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <label htmlFor={`campo-${c.chave}`}><strong>{c.chave}</strong></label>
          <small>{c.descricao}</small>
          <input
            id={`campo-${c.chave}`}
            type="text"
            value={c.valor == null ? "" : String(c.valor)}
            disabled
            readOnly
          />
          {c.requer_reiniciar ? <small>Requer reiniciar o app para valer.</small> : null}
        </div>
      ))}
    </section>
  );
}
